/* ============================================================
   Joffzart — Custom Wall Art Order
   Vanilla JS: live preview, artwork count, uploads, gift toggle, FAQ.
   No dependencies. Scoped to .jz-cwa instances.
   ============================================================ */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.jzInit === "true") return;
    root.dataset.jzInit = "true";

    var qs = function (sel, ctx) { return (ctx || root).querySelector(sel); };
    var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

    /* ---- references ---- */
    var artworkBlocks = qsa("[data-artwork]");          // up to 3 artwork inputs
    var countInputs   = qsa("[data-count-input]");      // 1 / 2 / 3 / gallery radios
    var galleryNote   = qs("[data-gallery-note]");
    var framesWrap    = qs("[data-preview-frames]");
    var previewCap    = qs("[data-preview-caption]");

    // per-artwork uploaded image data + orientation
    var state = { count: 1, gallery: false, art: {} };
    artworkBlocks.forEach(function (block) {
      var idx = block.getAttribute("data-artwork");
      state.art[idx] = { src: "", orientation: "portrait" };
    });

    /* ---- helpers ---- */
    function orientationClass(o) {
      if (o === "landscape") return "jz-frame__img--landscape";
      if (o === "square") return "jz-frame__img--square";
      return "";
    }

    function makeFrame(idx) {
      var data = state.art[idx] || { src: "", orientation: "portrait" };
      var frame = document.createElement("div");
      frame.className = "jz-frame jz-pframe";
      var mat = document.createElement("div");
      mat.className = "jz-frame__mat";
      var img = document.createElement(data.src ? "img" : "div");
      img.className = "jz-frame__img " + orientationClass(data.orientation);
      if (data.src) {
        img.src = data.src;
        img.alt = "Your uploaded image, preview " + idx;
      }
      mat.appendChild(img);
      frame.appendChild(mat);
      return frame;
    }

    function renderPreview() {
      if (!framesWrap) return;
      framesWrap.innerHTML = "";
      var n = state.gallery ? 4 : state.count;
      framesWrap.setAttribute("data-count", state.gallery ? "gallery" : String(n));

      if (state.gallery) {
        framesWrap.style.display = "grid";
        framesWrap.style.gridTemplateColumns = "1fr 1fr";
        framesWrap.style.gap = "14px";
        framesWrap.style.maxWidth = "300px";
        for (var g = 0; g < 4; g++) {
          var ph = document.createElement("div");
          ph.className = "jz-frame jz-pframe";
          var phMat = document.createElement("div");
          phMat.className = "jz-frame__mat";
          var phImg = document.createElement("div");
          phImg.className = "jz-frame__img jz-frame__img--square";
          phMat.appendChild(phImg);
          ph.appendChild(phMat);
          framesWrap.appendChild(ph);
        }
      } else {
        framesWrap.style.display = "flex";
        framesWrap.style.gridTemplateColumns = "";
        framesWrap.style.gap = "16px";
        framesWrap.style.maxWidth = n === 1 ? "230px" : "100%";
        for (var i = 1; i <= n; i++) {
          framesWrap.appendChild(makeFrame(String(i)));
        }
      }

      if (previewCap) {
        if (state.gallery) previewCap.textContent = "Gallery wall preview";
        else if (n === 1) previewCap.textContent = "Single artwork preview";
        else if (n === 2) previewCap.textContent = "Pair layout preview";
        else previewCap.textContent = "Triptych layout preview";
      }
    }

    function setArtworkVisibility() {
      artworkBlocks.forEach(function (block) {
        var idx = parseInt(block.getAttribute("data-artwork"), 10);
        var show = !state.gallery && idx <= state.count;
        block.hidden = !show;
      });
      if (galleryNote) galleryNote.hidden = !state.gallery;
    }

    /* ---- count selection ---- */
    countInputs.forEach(function (input) {
      input.addEventListener("change", function () {
        var val = input.value;
        if (val === "gallery") {
          state.gallery = true;
        } else {
          state.gallery = false;
          state.count = parseInt(val, 10) || 1;
        }
        setArtworkVisibility();
        renderPreview();
      });
    });

    /* ---- uploads + orientation ---- */
    artworkBlocks.forEach(function (block) {
      var idx = block.getAttribute("data-artwork");
      var fileInput = qs("input[type=file]", block);
      var trigger   = qs("[data-upload-trigger]", block);
      var nameLabel = qs("[data-upload-name]", block);
      var orient    = qs("[data-orientation]", block);

      if (trigger && fileInput) {
        trigger.addEventListener("click", function () { fileInput.click(); });
      }
      if (fileInput) {
        fileInput.addEventListener("change", function () {
          var file = fileInput.files && fileInput.files[0];
          if (!file) return;
          if (nameLabel) nameLabel.textContent = file.name;
          var reader = new FileReader();
          reader.onload = function (e) {
            state.art[idx].src = e.target.result;
            renderPreview();
          };
          reader.readAsDataURL(file);
        });
      }
      if (orient) {
        orient.addEventListener("change", function () {
          state.art[idx].orientation = orient.value;
          renderPreview();
        });
      }
    });

    /* ---- gift toggle ---- */
    var giftToggle = qs("[data-gift-toggle]");
    var giftFields = qs("[data-gift-fields]");
    if (giftToggle && giftFields) {
      giftToggle.addEventListener("change", function () {
        giftFields.classList.toggle("is-open", giftToggle.checked);
      });
    }

    /* ---- FAQ accordion (single open, accessible) ---- */
    qsa("[data-faq-item]").forEach(function (item) {
      var btn = qs("[data-faq-q]", item);
      var panel = qs("[data-faq-a]", item);
      if (!btn || !panel) return;
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        qsa("[data-faq-item]").forEach(function (other) {
          other.classList.remove("is-open");
          var op = qs("[data-faq-a]", other);
          var ob = qs("[data-faq-q]", other);
          if (op) op.style.maxHeight = null;
          if (ob) ob.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });

    /* ---- initial paint ---- */
    setArtworkVisibility();
    renderPreview();
  }

  function boot() {
    document.querySelectorAll(".jz-cwa").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Shopify theme editor re-render support
  document.addEventListener("shopify:section:load", function (e) {
    var node = e.target.querySelector(".jz-cwa");
    if (node) init(node);
  });
})();